module.exports = __webpack_public_path__ + "static/media/scorbit-vision-streamboard.0ced1502.png";